import { SubjectPageItem } from '@yandex-int/k-common/typings';

export const getDefaultGrade = (subjectPages: Array<SubjectPageItem>) => {
    return subjectPages[0]?.grade || null;
};
